import { gql } from 'graphql-request';

export const GET_OR_CREATE_USER = gql`
  query GetOrCreateUser {
    getOrCreateUser {
      id
      soundsEnabled
      toThrive
      isAllowedFeatureFlag
      language
      areActionsPrivate
      email
      firstName
      lastName
    }
  }
`;

export const UPDATE_USER_BY_PK = gql`
  mutation updateUserByPk(
    $id: uuid!
    $soundsEnabled: Boolean!
    $toThrive: String!
    $isAllowedFeatureFlag: Boolean!
    $language: String!
    $areActionsPrivate: Boolean!
  ) {
    updateUserByPk(
      pkColumns: { id: $id }
      _set: {
        soundsEnabled: $soundsEnabled
        toThrive: $toThrive
        isAllowedFeatureFlag: $isAllowedFeatureFlag
        language: $language
        areActionsPrivate: $areActionsPrivate
      }
    ) {
      id
      language
      areActionsPrivate
    }
  }
`;

export const GET_USER_INFO = gql`
  query UserInfo {
    me {
      toThrive
      soundsEnabled
      isAllowedFeatureFlag
      userGroup
      language
      areActionsPrivate
      email
      firstName
      lastName
      id
    }
  }
`;
